import { PrivacyInfoModel, PrivacyProfileModel, SetPrivacy } from "../static/privacy.model";
import api from "./api";
import { _getAxios, setAxiosHeader4Post } from "./serviceMain";

export async function getPrivacyInfo(groupCode: string, storeCode: string, card: string): Promise<PrivacyInfoModel | null> {

    const url = '/v3/customer/getprivacyinfo';

    let responseServer: PrivacyInfoModel | null = null;
    let queryParams = new URLSearchParams({
        GroupCode: groupCode,
        StoreCode: storeCode,
        Card: card
    })

    // await api.get(url, {
    //     headers: setAxiosHeader(url, queryParams),
    // }).then(response => {
    //     responseServer = response.data;
    // })

    // await _getAxios(url,'GET_PRIVACY_INFO','getPrivacyInfo',queryParams)
    await _getAxios(url,'','',queryParams)
        .then(response => {
            responseServer = response;
        });

    return responseServer;
}

export async function setPrivacy(body: SetPrivacy): Promise<string> {
    const url = '/v3/customer/setprivacy';

    let status: number = 0;

    await api.post(`${url}`, JSON.stringify(body), {
        headers: setAxiosHeader4Post(body)
    }).then((response) => {
        status = response?.status;
    });

    if (status === 200) {
        return 'OK';
    }
    else {
        return 'KO';
    }
}

export async function getPrivacyProfile(groupCode: string, storeCode: string, card: string): Promise<PrivacyProfileModel | null> {

    const url = '/v3/customer/getprivacyprofile';
    let queryParams = new URLSearchParams({
        GroupCode: groupCode,
        StoreCode: storeCode,
        Card: card
    });

    let responseServer: PrivacyProfileModel | null = null;
    // await api.get(url, {
    //     headers: setAxiosHeader(url, queryParams),
    // }).then(response => {
    //     responseServer = response.data;
    // })

    await _getAxios(url,'GET_PRIVACY_PROFILE','getPrivacyProfile',queryParams)
    .then(response => {
        responseServer = response;
    });

    return responseServer;
}